export const CITIES = [
  "Indianapolis",
  "Carmel",
  "Fishers",
  "Noblesville",
  "Westfield",
  "Zionsville",
  "Greenwood",
  "Plainfield",
  "Avon",
  "Brownsburg",
];

export default function Marquee() {
  return (
    <section
      aria-label="Service area"
      data-testid="service-area-marquee"
      className="overflow-hidden border-y border-slate-200 bg-white py-5"
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {[0, 1].map((copy) => (
          <ul
            key={copy}
            aria-hidden={copy === 1}
            className="flex shrink-0 items-center"
          >
            {CITIES.map((city) => (
              <li key={city} className="flex items-center">
                <svg
                  viewBox="0 0 32 32"
                  className="h-3 w-3 shrink-0"
                  aria-hidden="true"
                >
                  <path d="M29 3 L3 14.5 L13 18.5 Z" fill="#2D8CFF" />
                  <path d="M29 3 L13 18.5 L16.5 29 Z" fill="#0B1F3A" />
                </svg>
                <span className="mx-7 whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.18em] text-navy">
                  {city}
                </span>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </section>
  );
}
